import { type RichContent } from '@wix/ricos';
import React from 'react';

import { useConfig } from '../../contexts/config-context';
import { useFieldAttributes } from '../../contexts/field-attributes-context';
import { useFieldPropsV2 } from '../../contexts/field-props-context';

type DescriptionProps = {
  className?: string;
  children: (props: {
    content: RichContent;
    locale: string;
  }) => React.ReactNode;
};

export const Description = ({ className, children }: DescriptionProps) => {
  const { description } = useFieldPropsV2();
  const { descriptionId } = useFieldAttributes();
  const { language } = useConfig();

  if (!description) {
    return null;
  }

  return (
    <div className={className} id={descriptionId}>
      {children({ content: description, locale: language })}
    </div>
  );
};
